<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body">
		<form>
			<div class="vx-row">
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<small class="date-label">{{ $t("CompanyCreate.InitDate") }}</small>
					<datepicker
						name="initDate"
						v-model="timeWindow.init_date"
						:language="$vs.rtl ? langHe : langEn"
						:disabledDates="disabledDatesTo"
						:placeholder="$t('Select')"
						@input="emitUpdateTimeWindow"
					></datepicker>
				</div>
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<small class="date-label">{{ $t("CompanyCreate.EndDate") }}</small>
					<datepicker
						name="endDate"
						v-model="timeWindow.end_date"
						:language="$vs.rtl ? langHe : langEn"
						:disabledDates="disabledDatesTo"
						:placeholder="$t('Select')"
						@input="emitUpdateTimeWindow"
					></datepicker>
				</div>
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<small class="date-label">{{ $t("Routing.Table.InitHour") }}</small>
					<flat-pickr
						name="dataHourInit"
						class="w-full"
						v-model="timeWindow.init_hour"
						:config="configdateTimePicker"
						:placeholder="$t('Select')"
						@input="emitUpdateTimeWindow"
					/>
				</div>
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<small class="date-label">{{ $t("Routing.Table.EndHour") }}</small>
					<flat-pickr
						name="dataHourEnd"
						v-model="timeWindow.end_hour"
						class="w-full"
						:config="configdateTimePicker"
						:placeholder="$t('Select')"
						@input="emitUpdateTimeWindow"
					/>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";

export default {
	name: "RepeatTimeWindow",
	components: {
		vSelect,
		flatPickr,
		Datepicker,
	},
	props: {
		duration: {
			type: String,
			default: "",
		},
		showDate: null,
		timeWindow: {
			type: Object,
			default: {
				init_date: "",
				end_date: "",
				init_hour: "",
				end_hour: "",
			},
		},
	},
	data() {
		return {
			langHe: es,
			langEn: en,
			localTimeWindow: {...this.timeWindow},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
		};
	},
	watch: {
		timeWindow: {
			handler(newVal) {
				this.localTimeWindow = {...newVal};
			},
			deep: true,
		},
	},
	computed: {
		disabledDatesTo() {
			return {to: new Date(this.timeWindow.init_date)};
		},
	},
	methods: {
		emitUpdateTimeWindow() {
			this.$emit("updateTimeWindow", this.localTimeWindow);
		},
	},
};
</script>
<style lang="scss" scoped>
.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff !important;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
